import type { Priority } from "../../types";

export interface PipelineFilters {
  search: string;
  owner: string;
  minValue: string;
  priority: Priority | "";
}

export const EMPTY_FILTERS: PipelineFilters = { search: "", owner: "", minValue: "", priority: "" };

export function FiltersBar({
  filters,
  owners,
  onChange,
  onNewOpportunity,
}: {
  filters: PipelineFilters;
  owners: string[];
  onChange: (filters: PipelineFilters) => void;
  onNewOpportunity: () => void;
}) {
  return (
    <div class="filters-bar">
      <input
        class="filters-bar__search"
        type="search"
        placeholder="Search company or opportunity…"
        value={filters.search}
        data-ai-id="search"
        onInput={(e) => onChange({ ...filters, search: (e.target as HTMLInputElement).value })}
      />
      <select
        value={filters.owner}
        data-ai-id="filter-owner"
        onChange={(e) => onChange({ ...filters, owner: (e.target as HTMLSelectElement).value })}
      >
        <option value="">All owners</option>
        {owners.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
      <select
        value={filters.priority}
        data-ai-id="filter-priority"
        onChange={(e) => onChange({ ...filters, priority: (e.target as HTMLSelectElement).value as Priority | "" })}
      >
        <option value="">All priorities</option>
        <option value="Low">Low</option>
        <option value="Medium">Medium</option>
        <option value="High">High</option>
      </select>
      <input
        class="filters-bar__value"
        type="number"
        min="0"
        placeholder="Min value €"
        value={filters.minValue}
        data-ai-id="filter-min-value"
        onInput={(e) => onChange({ ...filters, minValue: (e.target as HTMLInputElement).value })}
      />
      <div class="filters-bar__spacer" />
      <button type="button" class="btn btn--primary" data-ai-id="create-opportunity" onClick={onNewOpportunity}>
        + New Opportunity
      </button>
    </div>
  );
}
